import { render, staticRenderFns } from "./TripTollView.vue?vue&type=template&id=af51ef70&scoped=true&"
import script from "./TripTollView.vue?vue&type=script&lang=js&"
export * from "./TripTollView.vue?vue&type=script&lang=js&"
import style0 from "./TripTollView.vue?vue&type=style&index=0&id=af51ef70&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af51ef70",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
